import type { Label } from "@/entities/label";

export const mockLabels: Label[] = [
  {
    id: "lbl-1",
    name: "Backofen",
    tenant_id: "1",
    color: "#EF4444",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-2",
    name: "Konvektomat",
    tenant_id: "1",
    color: "#F97316",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-3",
    name: "Konditorei",
    tenant_id: "1",
    color: "#EC4899",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-4",
    name: "Kühltheke",
    tenant_id: "1",
    color: "#3B82F6",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-5",
    name: "Tiefkühler",
    tenant_id: "1",
    color: "#06B6D4",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-6",
    name: "Kasse",
    tenant_id: "1",
    color: "#10B981",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-7",
    name: "Spülmaschine",
    tenant_id: "1",
    color: "#8B5CF6",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-8",
    name: "Kaffeemaschine",
    tenant_id: "1",
    color: "#A855F7",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-9",
    name: "Gärschrank",
    tenant_id: "1",
    color: "#FCD34D",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-10",
    name: "Teigmaschine",
    tenant_id: "1",
    color: "#84CC16",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-11",
    name: "Wartung fällig",
    tenant_id: "1",
    color: "#F59E0B",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-12",
    name: "Neugerät",
    tenant_id: "1",
    color: "#22D3EE",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-13",
    name: "Altgerät",
    tenant_id: "1",
    color: "#9CA3AF",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-14",
    name: "Kritisch",
    tenant_id: "1",
    color: "#DC2626",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "lbl-15",
    name: "Sonstiges",
    tenant_id: "1",
    color: "#6B7280",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
